import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
//Limitless imports
import { useNavigation } from "../../../hooks/navigation/NavigationContext";
import { useExpertProfileContext } from "../../../../expert/hooks/expert-profile/ExpertProfileContext";
import NavigationItem from "../navigation-item/NavigationItem";
import { modernLogoLight } from "@limitless/images";
import { modernLogoDark } from "@limitless/images";
import Grid from "@limitless/modern/layout/Grid";
const LeftNav = ({
  navItems
}) => {
  const location = useLocation();
  const {
    navigate
  } = useNavigation();
  const {
    canUserAccess,
    isDarkMode
  } = useExpertProfileContext();
  const renderLogo = () => {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sx: {
        marginBottom: 12
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: !isDarkMode ? modernLogoLight : modernLogoDark,
      style: {
        padding: "4px 12px",
        width: 56,
        height: "auto"
      }
    }));
  };
  const renderNavItems = () => {
    return navItems.map((item, index) => {
      const selected = item.path === location.pathname ? true : false;
      const allowAccess = item.policy ? canUserAccess(item.policy) : true;
      if (item.text && allowAccess) {
        var _item$childRoutes$fil, _item$childRoutes;
        const childRoutes = (_item$childRoutes$fil = (_item$childRoutes = item.childRoutes) === null || _item$childRoutes === void 0 ? void 0 : _item$childRoutes.filter(route => !route.path.includes(":") && route.text)) !== null && _item$childRoutes$fil !== void 0 ? _item$childRoutes$fil : [];
        if (childRoutes.length !== 0) {
          return (
            /*#__PURE__*/
            // <NavigationSubMenu
            //     key={index}
            //     id={index}
            //     navItem={item}
            //     onClickHandle={handleNavigation}
            //     canUserAccess={canUserAccess}
            // />
            React.createElement("div", null)
          );
        } else {
          return /*#__PURE__*/React.createElement(NavigationItem, {
            key: index,
            id: index,
            text: item.text,
            icon: item.icon,
            link: item.path,
            selected: selected,
            onClickHandle: (link, replace) => navigate(link, replace)
          });
        }
      }
      return null;
    });
  };
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    alignContent: "flex-start",
    sx: {
      borderRight: "1px solid #00000015",
      height: "100%",
      textAlign: "center"
    }
  }, renderLogo(), renderNavItems());
};
export default LeftNav;
LeftNav.propTypes = {
  navItems: PropTypes.array.isRequired
};